import GRBASDistributionGraph from "./GRBASDistributionGraph";
import { ApplicationContextualHelp } from "../../../../../components/application";

export default function GRBASFeedback({
  feedbackRows,
  onNext,
  isLastSample,
  continueLabel = null
}) {
  return (
    <div style={{ marginTop: 24 }}>
      <div className="app-module-section">
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <h2 style={{ margin: 0 }}>PVQD GRBAS reference distribution</h2>
          <ApplicationContextualHelp
            label="How should I interpret this reference distribution?"
            title="About this reference distribution"
          >
            <p>
              The bars show how PVQD GRBAS evaluations are distributed across
              the ordinal categories. Your rating is shown for comparison with
              that distribution.
            </p>
          </ApplicationContextualHelp>
        </div>

        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: 32
          }}
        >
          {feedbackRows.map((row) => (
            <GRBASDistributionGraph
              key={row.attribute}
              label={row.label}
              userOrdinal={row.userOrdinal}
              distribution={row.distribution}
            />
          ))}
        </div>
      </div>

      <div className="app-btn-container">
        <button
          type="button"
          className="app-btn app-btn-primary"
          onClick={onNext}
        >
          {continueLabel ||
            (isLastSample
              ? "Finish practice"
              : "Next sample")}
        </button>
      </div>
    </div>
  );
}
